





import {Component, Vue} from 'vue-property-decorator';
import {AppModule} from '@/store/modules/app';

@Component
export default class MoreMessageBox extends Vue {
  get isShowMoreMsg(): boolean {
    return AppModule.isShowMoreMsg
  }
}
